module.exports = __webpack_public_path__ + "img/banner3_3_zh.10b14b58.png";